import React from "react";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { Row, Col, Button, Card, Label } from "reactstrap";
import { InputText } from "primereact/inputtext";
import EditorContainer from "../../components/EditorContainer";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { createService, updateService, getService } from "../../api/service";
import { getTenant } from "../../api/tenants";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { getMakes, getModels, getPreparations } from "../../api/vehicles";
import useDebounce from "../../utils/debounceHook";
import EmailEditor from '../../components/EmailsEditor'
import { canUserSave } from "../../auth/Can";
import roles from "../../auth/roles";

const schema = () =>
    Yup.object({
        text: Yup.string().nullable().required('Impostare la email di notifica scadenza tagliando').typeError('Impostare la email di notifica scadenza tagliando'),
        attributes: Yup.object({
            type: Yup.string().required("Il tipo di veicolo é obbligatorio"),
            supplier: Yup.string(),
            infocarMake: Yup.string(),
            infocarModel: Yup.string(),
            infocarSupplier: Yup.string(),
            notes: Yup.string(),
            preparation: Yup.string(),
            make: Yup.string(),
            model: Yup.string(),
            km: Yup.number().required("Specificare la scadenza chilometrica").typeError('Specificare la scadenza chilometrica'),
            duration: Yup.number().required("Specificare la scadenza temporale in mesi").typeError('Specificare la scadenza temporale'),
            description: Yup.string().required('Inserire la descrizione del modello')
            /*             km: Yup.number().when('duration', (duration, schema) => {
                            return duration
                                ? schema.typeError("")
                                : schema.required(
                                    'Specificare la scadenza chilometrica e temporale'
                                ).typeError('Specificare la scadenza chilometrica e temporale');
                        }), */
        })
    });

const ServiceModelEditor = ({ activeTenant, readOnly }) => {

    const { id } = useParams();
    const { domains } = useAuth0();
    const [tenant, setTenant] = React.useState(activeTenant);
    const [modSvc, setModSvc] = React.useState()
    const [emailBuilder, setEmailBuilder] = React.useState(false);

    const [selectedSupplier, setSelectedSupplier] = React.useState(
        modSvc && modSvc.attributes
            ? modSvc.attributes.infocarSupplier
            : undefined)
    const [selectedMake, setSelectedMake] = React.useState(
        modSvc && modSvc.attributes ? modSvc.attributes.infocarMake : undefined);
    const [selectedModel, setSelectedModel] = React.useState(
        modSvc && modSvc.attributes ? modSvc.attributes.infocarModel : undefined);

    const debouncedSupplier = useDebounce(selectedSupplier, 500);
    const debouncedMake = useDebounce(selectedMake, 500);
    const debouncedModel = useDebounce(selectedModel, 500);
    const [makes, setMakes] = React.useState([]);
    const [models, setModels] = React.useState([]);
    const [preparations, setPreparations] = React.useState([]);

    const getDDTextInEvent = e =>
        e.originalEvent && e.originalEvent.currentTarget
            ? e.originalEvent.currentTarget.innerText
            : e.value;

    React.useEffect(() => {
        loadMakes();
    }, []);

    React.useEffect(() => {
        if (debouncedSupplier && debouncedMake) {
            loadModels(debouncedSupplier, debouncedMake);
        }
    }, [debouncedSupplier, debouncedMake]);

    React.useEffect(() => {
        if (debouncedModel) {
            loadPreparations(debouncedModel);
        }
    }, [debouncedModel]);

    async function loadMakes() {
        const makesList = await getMakes();
        setMakes(makesList);
    }

    async function loadModels(alimen, make) {
        const modelsList = await getModels(make, alimen || "0");

        setPreparations([]);
        setModels(modelsList);
    }

    async function loadPreparations(modello) {
        const modelsList = await getPreparations(modello);

        setPreparations(modelsList);
    }

    const onCreate = async entity => {
        const result = await createService({
            ...entity,
            tenant_id: activeTenant._id
        });
        return result;
    };

    const onLoad = async id => {
        const model = await getService(id);
        const tenantDett = await getTenant(model.tenant_id);
        setModSvc(model);
        setTenant(tenantDett);
        return model;
    };

    const onUpdate = async entity => {
        const result = await updateService(entity);
        return result;
    };

    const onAttributesChange = (
        changedProps,
        attributes,
        containerHandleChange
    ) => {
        const newAttributes = { ...attributes, ...changedProps };
        containerHandleChange("attributes", { target: { value: newAttributes } });
    };

    readOnly = emailBuilder;

    return (
        <EditorContainer
            key={id ? `${id}-svcModel` : "new-svcModel"}
            canSave={canUserSave([roles.SERVICE, roles.ADMIN], activeTenant)}
            readOnly={readOnly}
            schema={schema}
            onCreate={onCreate}
            onUpdate={onUpdate}
            onLoad={onLoad}
            optionalNav={{ link: `/tenant/services`, text: "Modelli Tagliando" }}
            redirRoot={`/tenant/services`}
            title={el =>
                `${el.attributes ? "Modello Tagliando: " + el.attributes.description : "NUOVO MODELLO"}`
            }
            children={(frmProps, containerHandleChange) => {
                const attributes = frmProps.values["attributes"] || {
                    model: "",
                    type: "",
                    supplier: "",
                    description: "",
                    make: "",
                    duration: "",
                    notes: "",
                    km: ""
                };

                const attributesErrors = frmProps.errors.attributes || {};
                const block = readOnly || attributes.hasNotifications;
                return (
                    <Row>
                        {!emailBuilder && (
                            <React.Fragment>
                                <Col sm="6" xs="12">
                                    <strong className="mt-2">Descrizione modello</strong>
                                    <InputText
                                        disabled={block ? true : false}
                                        className={attributesErrors.description ? "p-error" : ""}
                                        value={attributes.description || ""}
                                        style={{ width: "100%" }}
                                        onChange={e =>
                                            onAttributesChange(
                                                { description: e.target.value },
                                                attributes,
                                                containerHandleChange
                                            )
                                        }
                                    />
                                    {attributesErrors.description ? (<div className="invalid-feedback">{attributesErrors.description}</div>) : null}
                                </Col>
                                <Col sm="6" xs="12">
                                    <strong className="mt-2">Alimentazione</strong>
                                    <Dropdown
                                        filter
                                        filterBy="label"
                                        id="codSupplier"
                                        disabled={block ? true : false}
                                        className={attributesErrors.infocarSupplier ? "p-error" : ""}
                                        value={attributes.infocarSupplier || ""}
                                        showClear={true}
                                        style={{ width: "100%" }}
                                        options={domains.alimentazione.filter(el => el.value !== "0")}
                                        onChange={e => {
                                            onAttributesChange({
                                                infocarSupplier: e.value,
                                                supplier: getDDTextInEvent(e),
                                                model: "",
                                                infocarModel: "",
                                                preparation: ""
                                            }, attributes,
                                                containerHandleChange);
                                            setSelectedSupplier(e.value)
                                        }}
                                    />
                                </Col>
                                <Col sm="6" xs="12">
                                    <strong className="mt-2">Scadenza in Km</strong>
                                    <InputText
                                        disabled={block ? true : false}
                                        className={attributesErrors.km ? "p-error" : ""}
                                        value={attributes.km || ""}
                                        style={{ width: "100%" }}
                                        keyfilter="pint"
                                        onChange={e =>
                                            onAttributesChange(
                                                { km: e.target.value },
                                                attributes,
                                                containerHandleChange
                                            )
                                        }
                                    />
                                    {attributesErrors.km ? (<div className="invalid-feedback">{attributesErrors.km}</div>) : null}
                                </Col>

                                <Col sm="6" xs="12">
                                    <strong className="mt-2">Scadenza in mesi</strong>
                                    <InputText
                                        disabled={block ? true : false}
                                        className={attributesErrors.duration ? "p-error" : ""}
                                        value={attributes.duration || ""}
                                        style={{ width: "100%" }}
                                        keyfilter="pint"
                                        onChange={e =>
                                            onAttributesChange(
                                                { duration: e.target.value },
                                                attributes,
                                                containerHandleChange
                                            )
                                        }
                                    />
                                    {attributesErrors.duration ? (<div className="invalid-feedback">{attributesErrors.duration}</div>) : null}
                                </Col>

                                <Col sm="6" xs="12" md="6">
                                    <strong className="mt-2">Tipo Veicolo</strong>
                                    <Dropdown
                                        filter
                                        filterBy="label"
                                        id="vehicleType"
                                        disabled={block ? true : false}
                                        className={attributesErrors.type ? "p-error" : ""}
                                        value={attributes.type || ""}
                                        showClear={true}
                                        style={{ width: "100%" }}
                                        options={domains.vehicleTypes}
                                        onChange={e => {
                                            onAttributesChange({
                                                type: e.value,
                                                model: "",
                                                infocarModel: "",
                                                preparation: "",
                                                make: "",
                                                infocarMake: ""
                                            }, attributes,
                                                containerHandleChange);
                                        }}
                                        placeholder="selezionare il tipo di veicolo"
                                    />
                                    {attributesErrors.type ? (<div className="invalid-feedback">{attributesErrors.type}</div>) : null}
                                </Col>

                                <Col sm="6" xs="12" md="6">
                                    <strong className="mt-2">Marca</strong>
                                    <Dropdown
                                        filter
                                        editable
                                        filterBy="label"
                                        id="infocarMake"
                                        disabled={block ||
                                            !attributes.supplier || Number(attributes.supplier) === 0 || !attributes.type
                                        }
                                        className={attributesErrors.infocarMake ? "p-error" : ""}
                                        value={attributes.infocarMake || ""}
                                        showClear={true}
                                        style={{ width: "100%" }}
                                        options={makes.map(el => ({
                                            label: el.Descrizione,
                                            value: el.CodiceMarca
                                        }))}
                                        onChange={e => {
                                            onAttributesChange({
                                                infocarMake: e.value,
                                                make: getDDTextInEvent(e),
                                                model: "",
                                                infocarModel: "",
                                                preparation: ""
                                            }, attributes,
                                                containerHandleChange);
                                            setSelectedMake(e.value)
                                        }}
                                    />
                                </Col>
                                <Col sm="6" xs="12" md="6">
                                    <strong className="mt-2">Modello</strong>
                                    <Dropdown
                                        filter
                                        editable
                                        filterBy="label"
                                        id="infocarModel"
                                        disabled={block ? true : false}
                                        className={attributesErrors.infocarModel ? "p-error" : ""}
                                        value={attributes.infocarModel || ""}
                                        showClear={true}
                                        style={{ width: "100%" }}
                                        options={models.map(el => ({
                                            label: el.Descrizione,
                                            value: el.CodiceModello
                                        }))}
                                        onChange={e => {
                                            onAttributesChange({
                                                infocarModel: e.value,
                                                model: getDDTextInEvent(e),
                                                preparation: ""
                                            }, attributes,
                                                containerHandleChange);
                                            setSelectedModel(e.value)
                                        }}
                                    />
                                </Col>
                                <Col sm="6" xs="12" md="6">
                                    <strong className="mt-2">Allestimento</strong>
                                    <Dropdown
                                        filter
                                        editable
                                        filterBy="label"
                                        id="ddpreparation"
                                        disabled={block ? true : false}
                                        className={attributesErrors.preparation ? "p-error" : ""}
                                        value={attributes.preparation || ""}
                                        showClear={true}
                                        style={{ width: "100%" }}
                                        options={preparations.map(el => ({
                                            label: el.DescrizioneCompleta,
                                            value: el.DescrizioneCompleta
                                        }))}
                                        onChange={e => {
                                            onAttributesChange({
                                                preparation: getDDTextInEvent(e)
                                            }, attributes,
                                                containerHandleChange);
                                        }}
                                    />
                                </Col>
                                <Col sm="12" xs="12" md="12">
                                    <strong className="mt-2">Note</strong>
                                    <InputTextarea
                                        disabled={block ? true : false}
                                        rows={2}
                                        value={attributes.notes || ""}
                                        style={{ width: "100%" }}
                                        onChange={e =>
                                            onAttributesChange(
                                                { notes: e.target.value },
                                                attributes,
                                                containerHandleChange
                                            )
                                        }
                                    />
                                </Col>
                            </React.Fragment>
                        )}
                        <Col m="12" sxs="12" md="12" className="mt-2">
                            {!emailBuilder && (
                                <Button color="primary" className="mt-2" onClick={() => setEmailBuilder(true)}>CREA/MODIFICA EMAIL PER IL CLIENTE</Button>
                            )}
                            {emailBuilder && (
                                <div className="mailBuilderContainer" /* style={{ position: "relative", left: 0, right: 0, top: 0, bottom: 0, zIndex: 3000, height: "100%" }} */ >
                                    <EmailEditor
                                        onClose={() => setEmailBuilder(false)}
                                        initialValue={frmProps.values.design}
                                        projectId="4804"
                                        templateId={tenant.modelId}
                                        onSave={(design, html) => {
                                            containerHandleChange("design", { target: { value: design } })
                                            containerHandleChange("text", { target: { value: html } })
                                            setEmailBuilder(false)
                                        }} />
                                </div>
                            )}
                            {frmProps.errors.text ? (<div className="invalid-feedback">{frmProps.errors.text}</div>) : null}
                        </Col>

                    </Row>
                );
            }}
            renderDealer={() =>
                tenant ? (
                    <React.Fragment>
                        <Card body className="rounded bg-secondary mb-2">
                            <Row>
                                <Col sm="4" xs="12">
                                    <strong>Dealer: </strong>
                                    <Label className="h5">{tenant.name}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="3">
                                    <strong>Telefono: </strong>
                                    <Label className="h5">{tenant.phone}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="3">
                                    <strong>Email: </strong>
                                    <Label className="h5">{tenant.email}</Label>
                                </Col>
                            </Row>
                        </Card>
                    </React.Fragment>
                ) : (
                        <Spinner style={{ width: "3rem", height: "3rem" }} type="grow" />
                    )
            }
        />
    );
};
export default ServiceModelEditor;
